/**
 * @module paymentMethods
 * @description A list of paymentMethods
 */

export const paymentMethods = [
	'cheque',
	'card',
	'cash',
	'paypal',
	'wireTransfer',
	'cryptoCurrency',
	'mobileMoney',
] as const;
export type PaymentMethods = (typeof paymentMethods)[number];
